<template>
  <router-link class="t-flex" to="/">
    <div class="nav-bar-logo-container" :class="{ 'is-collapse': isCollapse }">
      <div class="nav-bar-logo" />
      <div class="nav-bar-logo-title">
        <span class="nav-bar-logo-name">Connect &amp; Integrate</span>
      </div>
    </div>  
  </router-link>
</template>
<script setup lang="ts">
import { useI18n } from "vue-i18n"

defineProps({
  isCollapse: {
    type: Boolean,
    default: false
  }
})

const { t } = useI18n()
</script>
<style lang="scss" scoped>
@use "@/styles/mixins/typography.scss" as *;

@import "@/styles/utilities/variables";
@import "@/styles/utilities/mixins";

.nav-bar-logo-container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  text-decoration: none;
  color: var(--telekom-color-text-and-icon-standard);
  max-width: $t-sidebar-width;

  &.is-collapse {
    .nav-bar-logo-title {
      display: none;
    }
  }
}
.nav-bar-logo {
  @include background-contain;

  width: 32px;
  height: 32px;
  background-image: url("./assets/dih-logo.svg");
  margin-right: var(--scl-spacing-10);
  flex-grow: 0;
  flex-shrink: 0;
}
.nav-bar-logo-title {
  @include tg-small-bold;

  text-transform: uppercase;
  margin-left: var(--scl-spacing-12);
  span {
    display: block;
  }
}
</style>
